import React from 'react';
import { FacebookFilled, InstagramFilled, YoutubeFilled, GlobalOutlined, MessageFilled, StarFilled, WhatsAppOutlined } from '@ant-design/icons';
import { FaTelegramPlane, FaTiktok } from 'react-icons/fa';
const icons = { facebook: FacebookFilled, instagram: InstagramFilled, youtube: YoutubeFilled, telegram: FaTelegramPlane, tiktok: FaTiktok, messenger: MessageFilled, whatsapp: WhatsAppOutlined, review: StarFilled };
export default function SiteLinkIcon({ type }) { const Icon = icons[type] || GlobalOutlined; return <Icon />; }
